<template>
  <div>
    <v-btn color="green" dark @click="openModal">
      <v-icon left>mdi-plus</v-icon>
      Crea RUC
    </v-btn>

    <v-dialog v-model="modal" persistent max-width="600px" scrollable>
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon class="error--text" @click="cerrarModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text max-height="600px" class="pa-0">
          <empresa-pop-up :modal.sync="modal" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>



<script>
import EmpresaPopUp from '../views/RU/CrearEmpresaPopUp.vue'
export default {
  name: 'ModalEmpresaPopUp',
  components: {
    EmpresaPopUp,
  },
  data: () => {
    return {
      modal: false,
    }
  },
  methods: {
    openModal() {
      this.modal = true
    },
    cerrarModal() {
      this.modal = false
    },
  },
}
</script>
